import getClusterResolutions from "./get-cluster-resolutions";
import getFunctionData from "./get-function-data";
import { ENV_DEV } from "./window";

/**
 * Process the function from the string
 * @param {String} input
 * @param {StorageItemProps} item
 * @param {MainClassProps} main
 */
const processFunction = (input, item, main) => {
  let index = 0;
  const map = new Map();
  const data = getFunctionData(input);
  const parameters = data.get("parameters")?.toString() || "";
  const name = data.get("name")?.toString() || "";

  const isColorFunction = /^(rgb|hsl|#)/.test(name);
  const isCalcFunction = /^calc/.test(name);
  const isNoneInitial = item.get("is-none-initial");

  const isSlashSeparator = isColorFunction && parameters.includes("/");
  const separatorType = isCalcFunction ? "▄" : "▌";
  const separator = isSlashSeparator ? "▃" : separatorType;
  const values = parameters.split(separator);

  map.set("is-multiple", true);
  map.set("is-fn", true);
  map.set("original", input);
  map.set("name", name);
  map.set("values", []);
  map.set("divider", isCalcFunction ? " " : ", ");
  map.set("is-composition", data.get("is-composition"));
  map.set("is-none-initial", false);
  map.set("is-slash", isSlashSeparator);

  if (isCalcFunction) {
    const replaced = parameters.replace(/▄/g, " ");

    map.set("is-calc", true);
    map.set("divider", ` ${/▄(.*?)▄/.exec(parameters)?.[1]} `);
    map.set("original", replaced);
    map.set("output", replaced);
  }

  for (const value of values) {
    if (["+", "-", "*", "/"].includes(value)) {
      continue;
    }

    if (ENV_DEV && value.startsWith("calc") && !isCalcFunction) {
      console.warn(
        `[TorusKit warn]: Deeply nested \`calc()\` functions are not supported. Found in \`${value.replace(
          /▄/g,
          " "
        )}\``
      );
      continue;
    }

    const valueMap = new Map();
    const resolutions = getClusterResolutions(value);

    const storage = /** @type {Array<any>} */ (main?.storage.get("values"));
    const path = item.get("path") || "";
    const isCoordinates = item.get("is-coordinates-based");
    const isParameter = item.get("is-parameter");

    valueMap.set("is-coordinates-based", isCoordinates);
    valueMap.set("is-none-initial", isNoneInitial);
    valueMap.set("is-slash", isSlashSeparator);
    valueMap.set("is-parameter", isParameter);
    valueMap.set("is-value", true);
    valueMap.set("original", value);
    valueMap.set("resolutions", resolutions);
    valueMap.set("path", `${path}>${index}`);
    valueMap.set("parent-item", item);

    map.get("values").push(valueMap);

    storage?.push(valueMap);

    ++index;
  }

  return map;
};

export default processFunction;
